import { render, staticRenderFns } from "./userReviewTranscript.vue?vue&type=template&id=67322d5c&scoped=true&lang=html&"
import script from "./userReviewTranscript.vue?vue&type=script&lang=ts&"
export * from "./userReviewTranscript.vue?vue&type=script&lang=ts&"
import style0 from "./userReviewTranscript.vue?vue&type=style&index=0&id=67322d5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67322d5c",
  null
  
)

export default component.exports